import { render, staticRenderFns } from "./VendorAccessDisabled.vue?vue&type=template&id=26ddcb98&scoped=true&"
import script from "./VendorAccessDisabled.vue?vue&type=script&lang=js&"
export * from "./VendorAccessDisabled.vue?vue&type=script&lang=js&"
import style0 from "./VendorAccessDisabled.vue?vue&type=style&index=0&id=26ddcb98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ddcb98",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCol,VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2143939116/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26ddcb98')) {
      api.createRecord('26ddcb98', component.options)
    } else {
      api.reload('26ddcb98', component.options)
    }
    module.hot.accept("./VendorAccessDisabled.vue?vue&type=template&id=26ddcb98&scoped=true&", function () {
      api.rerender('26ddcb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VendorAccessDisabled.vue"
export default component.exports